import React from "react";
import axios from "services/axios";
import _ from "lodash";
import { Card, message, Spin, Row } from "antd";
import ApprovalInformation from "../../Component/Section/ApprovalInformation";
import NewCarInformation from "../../Component/Section/NewCarInformation";
import CustomerInformation from "../../Component/Section/CustomerInformation";
import Discount from "../../Component/Section/Discount";
import RequestSection from "../../Component/Section/RequestSection";
import DealSection from "../../Component/Section/DealSection";
import ModalRequest from "../../Component/Modal/ModalRequest";
import ModalDeal from "../../Component/Modal/ModalDeal";
import ModalNoDeal from "../../Component/Modal/ModalNoDeal";

class NewCarInProgressDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      newCar: {},
      request: [],
      visibleModalRequest: false,
      visibleModalDeal: false,
      visibleModalNoDeal: false,
    };
    this.formatRupiah = this.formatRupiah.bind(this);
    this.visibleModal = this.visibleModal.bind(this);
    this.sendRequestButton = this.sendRequestButton.bind(this);
    this.sendDealButton = this.sendDealButton.bind(this);
    this.sendNoDealButton = this.sendNoDealButton.bind(this);
  }

  componentDidMount() {
    this.fetchNewCar(this.props.match.params.id);
    this.fetchReasonNoDeal();
  }

  // ************************* Function Fetch Data *************************//
  fetchNewCar(id) {
    this.setState({ isLoading: true });
    axios
      .get(`/admin-panel/new-car/detail/${id}`)
      .then(result => {
        this.setState({
          newCar: result.data.approvalNewCar,
          request: result.data.approvalRequestStatus,
          isLoading: false,
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        message.error("Gagal request data New Car");
      });
  }

  fetchReasonNoDeal() {
    axios
      .get(`/approval/reason-list`)
      .then(result => {
        this.setState({
          reasonNoDealList: result.data,
        });
      })
      .catch(err => {
        message.error("Gagal request reason no deal list");
      });
  }

  // ************************* Function Helper *************************//
  getValue(data, key, value) {
    let found;
    data = _.find(data, { [key]: value });
    if (data) {
      if (data.value) {
        found = data.value;
      } else if (data.price) {
        found = data.price;
      }
    }
    return found;
  }

  formatRupiah(number) {
    let data;
    if (number) {
      if (number !== "N/A") {
        data = `Rp.${number
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")},-`;
      } else {
        data = number;
      }
    } else {
      data = `Rp.0,-`;
    }
    return data;
  }

  // ************************* Function Open/Close Modal *************************//
  checkPermissionModal(type) {
    const { request } = this.state;
    let permission = false;
    const objPermissionFinish = ["Deal", "No Deal"];
    const requestInProgress = _.find(request, { status: "Dalam Proses" });

    if (requestInProgress) {
      if (objPermissionFinish.includes(type)) {
        message.error(`Request Discount Sedang Dalam Proses`);
      } else {
        permission = true;
      }
    } else {
      permission = true;
    }
    return permission;
  }

  visibleModal(type, val) {
    const permission = this.checkPermissionModal(type);
    if (permission) {
      switch (type) {
        case "Discount":
          this.setState({ visibleModalRequest: val, typeRequest: type });
          break;
        case "Deal":
          this.setState({ visibleModalDeal: val });
          break;
        case "No Deal":
          this.setState({ visibleModalNoDeal: val });
          break;
      }
    }
  }

  // ************************* Function Modal Send Button *************************//

  async sendRequestButton(data) {
    try {
      const idApproval = this.props.match.params.id;
      const branchId = this.state.newCar.BranchHead.SalesBranch.id;
      data = {
        ...data,
        branchId,
      };
      await axios.post(`/approval/new-car/${idApproval}`, data);
      message.success("Success Request Discount New Car");
      this.fetchNewCar(idApproval);
    } catch (e) {
      this.setState({ isLoading: false });
      message.error("Gagal send request");
    }
  }

  async sendDealButton(data) {
    try {
      const idApproval = this.props.match.params.id;
      await axios.put(`/approval/new-car/finish/${idApproval}`, data);
      message.success("Success Finish New Car");
      this.props.history.push(
        `/home/approval/new-car-in-${this.props.location.query.status}`
      );
    } catch (e) {
      message.error("Gagal Finish New Car");
    }
  }

  async sendNoDealButton(data) {
    try {
      const idApproval = this.props.match.params.id;
      await axios.put(`/approval/new-car/finish/${idApproval}`, data);
      message.success("Success Finish New Car");
      this.props.history.push(
        `/home/approval/new-car-in-${this.props.location.query.status}`
      );
    } catch (e) {
      message.error("Gagal Finish New Car");
    }
  }

  render() {
    const { newCar, request } = this.state;
    const { NewCar } = newCar;
    return newCar.id ? (
      <Card title="New Car">
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <div id="ApprovalNewCarDetail">
            <ApprovalInformation approval={newCar} approvalType="New Car" />
            <Row>
              <NewCarInformation
                edit={false}
                newCar={NewCar}
                formatRupiah={this.formatRupiah}
              />
              <CustomerInformation newCar={newCar} />
            </Row>
            <Row>
              <Discount
                approvalType="New Car"
                carPrice={NewCar ? NewCar.otr : "N/A"}
                request={request}
                formatRupiah={this.formatRupiah}
              />
              <RequestSection
                approvalType="New Car"
                request={request}
                visibleModal={this.visibleModal}
              />
            </Row>
            <Row>
              <DealSection
                approvalType="New Car"
                visibleModal={this.visibleModal}
              />
            </Row>

            <ModalRequest
              title="Discount"
              visible={this.state.visibleModalRequest}
              visibleModal={this.visibleModal}
              formatRupiah={this.formatRupiah}
              sendButton={this.sendRequestButton}
            />

            <ModalDeal
              approvalType="New Car"
              hargaMobil={NewCar ? NewCar.otr : 0}
              visible={this.state.visibleModalDeal}
              formatRupiah={this.formatRupiah}
              sendButton={this.sendDealButton}
              visibleModal={this.visibleModal}
            />
            <ModalNoDeal
              visible={this.state.visibleModalNoDeal}
              reason={this.state.reasonNoDealList}
              sendButton={this.sendNoDealButton}
              visibleModal={this.visibleModal}
            />
          </div>
        </Spin>
      </Card>
    ) : null;
  }
}

export default NewCarInProgressDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/NewCar/InProgress/NewCarDetail.js